export interface AiChatUiMessage {
    id: string;
    isUser: boolean;
    isSystem: boolean;
    text: string;
//    sanitizedText: string | null;
    timestamp: Date;
    conversationId: string;
}

export type AiChatContext =  {
    messages: AiChatUiMessage[];
};

export class AiChatMessageStorage {
    private readonly context: AiChatContext;

    constructor(context: AiChatContext) {
        this.context = context;
        if (!Array.isArray(this.context.messages)) {
            this.context.messages = [];
        }
    }

    get chatContext(): AiChatContext {
        return this.context as AiChatContext;
    }

    get messages(): AiChatUiMessage[] {
        return this.context.messages!;
    }

    get hasMessages(): boolean {
        return this.messages.length > 0;
    }

    addUserMessage(text: string, conversationId: string): AiChatUiMessage {
        const message = this.createMessage(true, text, conversationId);
        this.messages.push(message);
        return message;
    }

    addAssistantMessage(text: string, conversationId: string): AiChatUiMessage {
        const message = this.createMessage(false, text, conversationId);
        this.messages.push(message);
        return message;
    }

    clearMessages(): void {
        this.messages.splice(0, this.messages.length);
    }

    private createMessage(isUser: boolean, text: string, conversationId: string): AiChatUiMessage {
        return {
            id: `msg-${Date.now()}-${Math.floor(Math.random() * 100000)}`,
            isUser,
            isSystem: false,
            text,
            timestamp: new Date(),
            conversationId: conversationId
        };
    }
}



// WEBPACK FOOTER //
// ./../Shared/packages/ai/message-storage.ts